var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFundPayrollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5851 9.24816V7.41406H14.751",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.166 9.51044L11.3453 8.33111L13.8342 10.1652L16.5854 7.41406",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.834 13.3755L16.5851 13.3756",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.834 16.1264L16.5851 16.1265",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74609 13.4668V19.7027C3.74714 20.5129 5.3884 21.17 7.41429 21.17C9.44018 21.17 11.0814 20.5129 11.0825 19.7027V13.4668",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0814 13.4673C11.0814 14.2774 9.43913 14.9346 7.41324 14.9346C5.38735 14.9346 3.74609 14.2774 3.74609 13.4673C3.74609 12.6561 5.38944 12 7.41429 12C9.43913 12 11.0814 12.6571 11.0825 13.4673",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74707 16.585C3.74707 17.3951 5.38833 18.0522 7.41422 18.0522C9.44011 18.0522 11.0824 17.3951 11.0824 16.585",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58008 9.24839V5.58019C5.58008 4.56725 6.40123 3.74609 7.41418 3.74609H18.4188C19.4317 3.74609 20.2529 4.56725 20.2529 5.58019V17.5018C20.2529 18.5148 19.4317 19.3359 18.4188 19.3359H13.8335",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundPayrollIcon);
export default __webpack_public_path__ + "static/media/fund-payroll-icon.1adfe143a952f7a67fcb6f26ecf007d3.svg";
export { ForwardRef as ReactComponent };